export const outline = `2px solid var(--mui-palette-primary-main)`;
